import SummaryListTabContent from './SummaryListTabContent';

export default SummaryListTabContent;